import { css } from "../../../../../styled-system/css";

export const styles = {
  root: () =>
    css({
      position: "relative",
      paddingBottom: "baseUnit.mobile9",
    }),
  wrapper: () =>
    css({
      display: "grid",
      gridTemplateColumns: "1fr",
      gridTemplateRows: "auto",
      gap: "baseUnit.mobile3",
      paddingTop: "baseUnit.mobile3",
      desktop: {
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "auto auto",
      },
    }),
};
